<section
  class="navigation box-shadow"
  [ngClass]="{ 'navigation-open': menu_open }"
  *ngIf="i18n != undefined"
>
  <section class="navigation-wrapper">
    <section
      class="imgbox fancy-font screen-only"
      routerLink="/"
      style="text-align: center;"
    >
      <img src="./../../assets/img/nura_ava.png" /><br />
      <h1>NuraRay</h1>
    </section>
    <section class="mobile-only">
      <div routerLink="/" class="title fancy-font">NuraRay</div>
      <button (click)="menu_open = !menu_open">...</button>
      <br />
      <br />
    </section>
    <hr />
    <section class="nav-link-wrapper">
      <ul>
        <li class="li-first">
          {{ i18n.nav.ressources }}
          <ul>
            <li routerLink="/mv-tilesets" class="li-second">
              {{ i18n.nav.mv_tiles }}
            </li>
            <li routerLink="/engine-free" class="li-second">
              {{ i18n.nav.engine_free }}
            </li>
          </ul>
        </li>
        <li class="li-first">
          {{ i18n.nav.games }}
          <ul>
            <li routerLink="/games/nachtschatten" class="li-second">
              {{ i18n.nav.nachtschatten }}
            </li>
            <li routerLink="/games/bloxxs" class="li-second">
              {{ i18n.nav.bloxxs }}
            </li>
            <li routerLink="/games/hans-dampf-machine" class="li-second">
              {{ i18n.nav.hans_dampf }}
            </li>
            <li routerLink="/games/cthulhu-clicker" class="li-second">
              {{ i18n.nav.cthulhu }}
            </li>
            <li routerLink="/games/halloween-im-hexenhaus" class="li-second">
              {{ i18n.nav.halloween }}
            </li>
            <li routerLink="/games/au-schwarte" class="li-second">
              {{ i18n.nav.au_schwarte }}
            </li>
          </ul>
        </li>
        <li class="li-first">
          {{ i18n.nav.apps }}
          <ul>
            <li routerLink="/apps/draw-it" class="li-second">
              {{ i18n.nav.draw_it }}
            </li>
            <li routerLink="/apps/dreaming-fox" class="li-second">
              {{ i18n.nav.dreaming_fox }}
            </li>
          </ul>
        </li>
        <li routerLink="/contact" class="li-first li-single">
          {{ i18n.nav.kontakt }}
        </li>
      </ul>
    </section>
  </section>
  <section class="flag-container">
    <img
      class="flag"
      src="../../../assets/img/icons/eng.svg"
      (click)="changeLang('en')"
      alt=""
    />
    <img
      class="flag"
      src="../../../assets/img/icons/ger.svg"
      (click)="changeLang('de')"
      alt=""
    />
  </section>
</section>
